import { TooltipElement } from "./tooltipElementDataTip";
export class Tooltip {
    private static e: TooltipElement;
    private listener: (evt: any) => void;
    constructor(element) {
        this.listener = (evt) => {
            this.show(element);
        };
        element.addEventListener("mouseenter", this.listener);
        element.addEventListener("mouseleave", () => this.remove(element));
    }

    public static bindElement(element: HTMLElement) {
        new Tooltip(element);
    }

    private show = (element) => {
        if (element.getAttribute("data-tip") == null) {
            return;
        }
        // Otherwise Firefox keeps dispatching the event when the dom is changed.
        element.removeEventListener("mouseenter", this.listener);
        Tooltip.e = document.createElement("s6-tooltip-data-tip") as TooltipElement;
        document.body.appendChild(Tooltip.e);
        Tooltip.e.element = element;
    }
    private remove = (element) => {
        element.addEventListener("mouseenter", this.listener);
        if (Tooltip.e != null) {
            Tooltip.e.element = null;
        }
    }
}
